import type { AuditFork } from '@vibecontrol/shared/roleforge';
import { Briefcase, Rocket } from 'lucide-react';

interface Props {
  onPick: (fork: AuditFork) => void;
  disabled?: boolean;
}

export function AuditForkPicker({ onPick, disabled }: Props) {
  return (
    <div className="grid md:grid-cols-2 gap-6">
      <button
        type="button"
        disabled={disabled}
        onClick={() => onPick('audit')}
        className="group min-h-72 text-left rounded-2xl border border-line bg-card p-8 shadow-soft transition duration-300 hover:-translate-y-1 hover:border-coral hover:shadow-card-lift focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-coral focus-visible:ring-offset-4 focus-visible:ring-offset-paper disabled:translate-y-0 disabled:opacity-50"
      >
        <span className="mb-6 inline-flex rounded-xl border border-coral/20 bg-brand-coral/10 p-3 transition group-hover:bg-brand-coral/15">
          <Briefcase className="h-9 w-9 text-coral" aria-hidden="true" />
        </span>
        <h3 className="mb-3 font-display text-2xl font-semibold tracking-tight text-ink">I have an existing business</h3>
        <p className="leading-relaxed text-graphite">
          We'll review how your team operates today, find the highest-impact AI opportunities,
          and propose an agent team that fits your workflow.
        </p>
      </button>

      <button
        type="button"
        disabled={disabled}
        onClick={() => onPick('forge')}
        className="group min-h-72 text-left rounded-2xl border border-line bg-card p-8 shadow-soft transition duration-300 hover:-translate-y-1 hover:border-coral hover:shadow-card-lift focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-coral focus-visible:ring-offset-4 focus-visible:ring-offset-paper disabled:translate-y-0 disabled:opacity-50"
      >
        <span className="mb-6 inline-flex rounded-xl border border-coral/20 bg-brand-coral/10 p-3 transition group-hover:bg-brand-coral/15">
          <Rocket className="h-9 w-9 text-coral" aria-hidden="true" />
        </span>
        <h3 className="mb-3 font-display text-2xl font-semibold tracking-tight text-ink">I'm building or launching</h3>
        <p className="leading-relaxed text-graphite">
          We'll design an AI Workforce Blueprint from scratch — offer, audience, journey, agent team —
          tailored to what you want to build.
        </p>
      </button>
    </div>
  );
}
